<script lang="ts">
	import Page from "#/layout/Page.svelte";
	import { flow } from "#/lib/flow.module.css";
	import { Error as Icon } from "#/lib/icons.ts";
	import { input } from "#/lib/input.module.css";
	import { container, panel, title } from "#/lib/panel.module.css";

	interface Props {
		error: unknown;
	}

	const { error }: Props = $props();
</script>

<Page icon={Icon} title="Error">
	<div class={container}>
		<div class="{panel} {flow}">
			{#if error instanceof Error}
				<h2 class={title}>{error.message}</h2>
				<pre>{error.stack}</pre>
			{:else}
				<pre>{error}</pre>
			{/if}

			<div>
				<button class={input} onclick={() => console.error(error)}>Print to console</button>
			</div>
		</div>
	</div>
</Page>

<style>
	pre {
		line-height: 1.2;
	}
</style>
